import request from '@/utils/request'

const pg = username => {
  return request({
    url: `/api/autoLogin/pg/${username}`,
    method: 'get'
  })
}

const betflix = username => {
  return request({
    url: `/api/autoLogin/betflix/${username}`,
    method: 'get'
  })
}

const askmebet = (username, password) => {
  return request({
    url: `/api/autoLogin/askmebet/${username}/${password}`,
    method: 'get'
  })
}

const imi = (username, password) => {
  return request({
    url: `/api/autoLogin/imi/${username}/${password}`,
    method: 'get'
  })
}

const usun = (username, password) => {
  return request({
    url: `/api/autoLogin/usun/${username}/${password}`,
    method: 'get'
  })
}

const areaslot = username => {
  return request({
    url: `/api/autoLogin/areaslot/${username}`,
    method: 'get'
  })
}

const circus = (username, password) => {
  return request({
    url: `/api/autoLogin/circus/${username}/${password}`,
    method: 'get'
  })
}

const slotracha = (username, password) => {
  return request({
    url: `/api/autoLogin/slotracha/${username}/${password}`,
    method: 'get'
  })
}

const pgslot = (username, password) => {
  return request({
    url: `/api/autoLogin/pgslot/${username}/${password}`,
    method: 'get'
  })
}

const joker2 = username => {
  return request({
    url: `/api/autoLogin/joker2/${username}`,
    method: 'get'
  })
}

const huayhd = username => {
  return request({
    url: `/api/autoLogin/huayhd/${username}`,
    method: 'get'
  })
}

const pglaz = username => {
  return request({
    url: `/api/autoLogin/pglaz/${username}`,
    method: 'get'
  })
}

const betflixnew = (username, provider, gamecode) => {
  return request({
    url: `/api/autoLogin/betflixnew/${username}`,
    method: 'get',
    params: { provider, gamecode }
  })
}

export default {
  pg,
  betflix,
  askmebet,
  imi,
  usun,
  areaslot,
  circus,
  slotracha,
  pgslot,
  joker2,
  huayhd,
  pglaz,
  betflixnew
}
